import React, { useRef, useEffect, useCallback, useState} from 'react';
import {searchPacks} from './searchPacks.js';
import PackSearch from './PackSearch.js';
import PackOption from "components/packs/PackOption.js";
import {getPacks} from 'packs/packs.js';
import {
    setCurrentSoundInList,
    setPackSelected
} from 'actions/index.js';
import {connect} from 'react-redux';

const PacksSelector = ({
    sequencerEngine,
    setCurrentSoundInList,
    setPackSelected,
    packSelected,
    showPianoRoll,
    bottomHeight
}) => { 
    const [searchTerm, setSearchTerm] = useState('');
    const [packs, setPacks] = useState([]);
    const [filteredPacks, setFilteredPacks] = useState(undefined);
    let ref = useRef(undefined);

    useEffect(() => {
        if (searchTerm !== '') {
            searchPacks(searchTerm).then(
                (packs) => {
                    setFilteredPacks(packs);
                });
        } else {
            setFilteredPacks(undefined);
        }
    }, [searchTerm, setFilteredPacks, packs]);

    useEffect(() => {
        getPacks().then((packs) => {
            console.log('get packs called=', packs);
            setPacks(packs);
        });
    }, []);

    useEffect(() => {
        return () => setPackSelected(undefined);
    }, []);

    let style = {
        maxHeight: window.innerHeight - 293
    };
    if (showPianoRoll) {
        style.maxHeight -= bottomHeight - 130;
    }

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [packSelected, packs]);

    const onKeyDown = useCallback((e) => {
        let _packs = filteredPacks || packs;
        if (e.key === 'ArrowLeft') {
            let index = _packs.indexOf(packSelected);
            setPackSelected(_packs[Math.max(0,index - 1)]);
            setCurrentSoundInList(0);
        } else if (e.key === 'ArrowRight') {
            let index = _packs.indexOf(packSelected);
            setPackSelected(_packs[Math.min(_packs.length - 1, index + 1)]);
            setCurrentSoundInList(0);
        }
    }, [packSelected, packs, filteredPacks]);

    return (
        <div
          className="packs-selector no-select">
          <PackSearch onChange={setSearchTerm}/>
          <div
            style={style}
            ref={ref}
            className="packs-grid">
            {(filteredPacks || packs).map(
                x =>
                    <PackOption sequencerEngine={sequencerEngine} key={x.packHash} scrollRef={ref} pack={x}/>
            )}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight,
      packSelected: state.packs.packSelected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPackSelected: x => dispatch(setPackSelected(x)),
      setCurrentSoundInList: x => dispatch(setCurrentSoundInList(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PacksSelector);
